(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("bookito-widget", [], factory);
	else if(typeof exports === 'object')
		exports["bookito-widget"] = factory();
	else
		root["bookito-widget"] = factory();
})(self, () => {
return 